module.exports = {"id":"169595","name":"Danny Rose","rating":"81","photo":"./data/images/photos/2/169595.png","club":{"name":"Tottenham Hotspur","logo":"./data/images/clubs/TottenhamHotspur.png"},"positions":["DG","DLG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DannyRose0.json
// module id = 963
// module chunks = 0